import loadable from '@loadable/component';

const PostsList = loadable(() => import('./PostsList'));

export { PostsList };
